import styled from '@emotion/styled';
import React, { FC } from 'react';
import { Button } from '../components/Button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Text = styled.p`
  letter-spacing: 0;
`;

const Queue = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
`;

const currentRunningTaskValidator = (currentRunningTask?: string) =>
  (taskId: string) => {
    if (!currentRunningTask || !taskId) {
      return false;
    }

    return currentRunningTask === taskId;
  };

interface SandboxQueueProps {
  currentRunningTask?: string;
  queue?: {
    elements: any[];
  };
}

export const SandboxQueue: FC<SandboxQueueProps> = ({ queue, currentRunningTask }) => {
  const isCurrentRunningTask = currentRunningTaskValidator(currentRunningTask);

  return <Container>
    {queue && queue?.elements.map(task =>
      <Queue key={task.id}>
        <Text>{task.id}</Text>
        <Text>{task.actor}</Text>
        {isCurrentRunningTask(task.id) && <Button>Running</Button>}
        {!isCurrentRunningTask(task.id) && <Button>Cleanup</Button>}
      </Queue>)}
  </Container>;
};
